import './App.css';
import React, { useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker, InfoWindow, Polyline, StreetViewPanorama } from '@react-google-maps/api';
import redIcon from './assets/red_icon.png';
import blueIcon from './assets/blue_icon2.png';
import greenIcon from './assets/green_icon.png';
import Amenities from './Amenities';
import axios from 'axios';
import { Button } from '@mui/material';
import { FilterBy } from './filterby/FilterBy';
import { SelectPos } from './select/SelectPos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'; 
import DrivingIconSVG from './icon/DrivenIconSVG';
import WalkingIconSVG from './icon/WalkingIconSVG';

const containerStyle = {
    height: '100vh',
    width: '100%'
};

// Base size of the marker infoWindows
const windowSizers = {
    maxWidth: '300px',
    minWidth: '200px',
    PaddingLeft: '14px',
    paddingRight: '8px'
};

const grandCaymanCenter = {
    lat: 19.339047,
    lng: -81.242406
};

const littleCaymanCenter = {
    lat: 19.68892,
    lng: -80.036696
};

const caymanBracCenter = {
    lat: 19.722171,
    lng: -79.801557
};

// Default styling for the markers
const options = {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.35,
    clickable: false,
    draggable: false,
    editable: false,
    radius: 30000,
    zIndex: 1
};

function App() {
    const [markers, setMarkers] = React.useState([]);
    const [map, setMap] = React.useState(null);
    const [selectedMarker, setSelectedMarker] = React.useState(null);
    const [panoramaCenter, setPanoramaCenter] = React.useState(null);
    const [filterValueList, setFilterValueList] = React.useState([]);
    const [mapCenter, setMapCenter] = React.useState(grandCaymanCenter);
    const [mapZoom, setMapZoom] = React.useState(12);

    const [list, setList] = React.useState({
        'Boat Ramp/Dock': false,
        'Cabanas/Benches': false,
        'Dogs Allowed': false,
        Playground: true,
        Restrooms: true,
        Sports: false,
        Swimming: true,
        'Wheelchair Access': false,
        Vendors: false
    });

    React.useEffect(() => {
        axios
            .get('/plc_map/getPlcMarkers')
            .then((response) => {
                setMarkers(response.data[0].content);
            })
            .catch((err) => {
                console.log('Unable to retrieve marker data.', err);
            });
    }, []);

    // React.useEffect(() => {}, [list]);

    const shouldDisplayMarker = (amenities) => {
        if (filterValueList.length > 0) {
            let didPass = true;
            filterValueList.forEach((entry) => {
                if (!amenities.includes(entry)) didPass = false;
            });
            return didPass;
        } else {
            return true;
        }
    };

    const [mapCenterName, setMapCenterName] = useState('grandCaymanCenter');

    const handleIslandRadioChange = (event) => {
        if (event === 'grand') {
            setMapCenterName('grandCaymanCenter');
            setMapCenter(grandCaymanCenter);
            setMapZoom(12);
        }
        if (event === 'little') {
            setMapCenterName('littleCaymanCenter');
            setMapCenter(littleCaymanCenter);
            setMapZoom(13);
        }
        if (event === 'brac') {
            setMapCenterName('caymanBracCenter');
            setMapCenter(caymanBracCenter);
            setMapZoom(13);
        }
    };

    const [flag, setFlag] = useState(false);

    useEffect(() => {
        if (flag) {
            const newList = [];
            setFlag(false);
            Object.keys(list).forEach((row) => {
                if (list[row])
                    switch (row) {
                        case 'Boat Ramp/Dock':
                            newList.push('dock');
                            break;
                        case 'Cabanas/Benches':
                            newList.push('cabanas');
                            break;
                        case 'Dogs Allowed':
                            newList.push('dogs');
                            break;
                        case 'Playground':
                            newList.push('playground');
                            break;
                        case 'Restrooms':
                            newList.push('bathrooms');
                            break;
                        case 'Sports':
                            newList.push('sports');
                            break;
                        case 'Swimming':
                            newList.push('swimming');
                            break;
                        case 'Wheelchair Access':
                            newList.push('wheelchair_access');
                            break;
                        case 'Vendors':
                            newList.push('vendors');
                            break;
                        default:
                        // code block
                    }
            });
            setFilterValueList(newList);
        }
    }, [filterValueList, list]);

    return (
        <div className="container">
            <div className="content">
                <div className="App">
                    <LoadScript googleMapsApiKey="AIzaSyCJtyVskKWbGsbqPvG85Hv7c8cC4fNCad4">
                        <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={mapCenter}
                            zoom={mapZoom}
                            ref={(map) => setMap(map)}
                            onClick={() => setSelectedMarker(null)}
                            options={{
                                mapTypeId: 'hybrid',
                                labels: true,
                                fullscreenControl: false,
                                restriction: {
                                    latLngBounds: {
                                        north: 20.232253,
                                        south: 18.616989,
                                        west: -82.220425,
                                        east: -79.090777
                                    },
                                    strictBounds: false
                                }
                            }}
                        >
                            {panoramaCenter && (
                                <StreetViewPanorama
                                    options={{
                                        panControl: true
                                    }}
                                    position={panoramaCenter}
                                    visible={panoramaCenter ? true : false}
                                    onCloseClick={() => {
                                        setPanoramaCenter(false);
                                    }}
                                />
                            )}

                            {markers && markers.map(function (marker, index) {
                                const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                                const isAndroid = /Android/.test(navigator.userAgent);
                                const isGoogleMapsInstalled = isAndroid && typeof window.plugins !== 'undefined' && typeof window.plugins.googlemaps !== 'undefined';

                                const openInGoogleMaps = (mode) => {
                                    if (isGoogleMapsInstalled) {
                                        // Abrir en Google Maps si está instalado
                                        window.plugins.googlemaps.external.launchNavigation({
                                            latitude: marker.lat,
                                            longitude: marker.lng,
                                            transportMode: mode // 'driving' o 'walking'
                                        });
                                    } else {
                                        // Abrir en el navegador si no está instalado
                                        window.open(`https://www.google.com/maps/dir/?api=1&destination=${marker.lat},${marker.lng}&travelmode=${mode}`);
                                    }
                                };

                                const openInAppleMaps = (mode) => {
                                    window.open(`https://maps.apple.com/?daddr=${marker.lat},${marker.lng}&dirflg=${mode === 'driving' ? 'd' : 'w'}`);
                                };

                                const iconSize = '32px';

                                return (
                                    <Marker key={index} position={{ lat: marker.lat, lng: marker.lng }} title={marker.name} onClick={() => setSelectedMarker(index)} visible={shouldDisplayMarker(marker.amenities)} icon={selectedMarker === index ? greenIcon : marker.color === 'red' ? redIcon : blueIcon}>
                                        {selectedMarker === index && (
                                            <InfoWindow position={{ lat: marker.lat, lng: marker.lng }} onCloseClick={() => setSelectedMarker(null)}>
                                                <div style={windowSizers}>
                                                    <h1 style={{ fontFamily: 'Helvetica' }}>{marker.name}</h1>
                                                    {!marker.noView && (
                                                        <div style={{ display: 'flex' }}>
                                                            <button onClick={() => openInGoogleMaps('driving')} style={{ margin: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5px' }}>
                                                                <DrivingIconSVG width={iconSize} height={iconSize} />
                                                                <span style={{ marginLeft: '5px' }}>Get Driving Directions</span>
                                                            </button>

                                                            <button onClick={() => openInGoogleMaps('walking')} style={{ margin: '5px', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '5px' }}>
                                                                <WalkingIconSVG width={iconSize} height={iconSize} />
                                                                <span style={{ marginLeft: '5px' }}>Get Walking Directions</span>
                                                            </button>
                                                            {/* {isIOS ? <button onClick={() => openInAppleMaps('driving')}>Open in Apple Maps</button> : <button onClick={() => openInGoogleMaps('driving')}>Open in Google Maps</button>} */}
                                                        </div>
                                                    )}

                                                    <Amenities amenitiesList={marker.amenities}></Amenities>
                                                </div>
                                            </InfoWindow>
                                        )}
                                        <Polyline visible={selectedMarker === index} path={marker.path} options={options} />
                                    </Marker>
                                );
                            })}
                        </GoogleMap>
                    </LoadScript>
                </div>
            </div>
            <div style={{ position: 'absolute', top: '50px', left: '10px' }}>
                {panoramaCenter && (
                    <Button
                        onClick={() => {
                            setPanoramaCenter(false);
                            setSelectedMarker(null);
                        }}
                        variant="contained"
                        style={{
                            backgroundColor: '#ffffff',
                            color: '#4f4f4f',
                            zIndex: '1',
                            marginTop: '30px',
                            textTransform: 'none'
                        }}
                        startIcon={<ArrowBackIosIcon />}
                    >
                        Back to Map
                    </Button>
                )}
                <FilterBy list={list} setList={setList} setFlag={setFlag} />
                <SelectPos mapCenterName={mapCenterName} handleIslandRadioChange={handleIslandRadioChange} />
            </div>
        </div>
    );
}

export default App;
